import { SelectOption } from '@consigli/facade';
import { Label, RadioGroupItem, RadioGroup as ShadRadioGroup } from '@consigli/shadcn';

interface RadioGroupProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
}

export const RadioGroup = ({ options, value, onChange }: RadioGroupProps) => {
  return (
    <ShadRadioGroup value={value} onValueChange={onChange}>
      {options.map((option) => (
        <div className="flex items-center space-x-2" key={option.value}>
          <RadioGroupItem value={option.value as string} id={option.label as string} />
          <Label htmlFor={option.label}>{option.label}</Label>
        </div>
      ))}
    </ShadRadioGroup>
  );
};
